/* eslint-disable @next/next/no-html-link-for-pages */
import { NovaLogo } from "@/svg"
import clsx from "clsx"
import { BreadCrumbs } from "../BreadCrumbs"
import { JoinNovaButton } from "./JoinNovaButton"

export const NAV_HEIGHT = 72

export const UnauthorizedNav: React.FC<{
  breadCrumbs?: { text: string; link?: string }[]
  className?: string
}> = ({ breadCrumbs, className }) => {
  return (
    <nav
      style={{
        height: `${NAV_HEIGHT}px`,
      }}
      className={clsx("z-100 flex w-full flex-row items-center justify-between p-3", className)}
      id="nav">
      <div className="flex flex-row items-center">
        <a href="/">
          <NovaLogo height={30} width={28} />
        </a>
        <div className="ml-6 hidden flex-row sm:flex">
          {breadCrumbs && breadCrumbs.length > 0 && <BreadCrumbs breadCrumbs={breadCrumbs} />}
        </div>
      </div>
      <JoinNovaButton />
    </nav>
  )
}
